module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADED = exports.LOADED = 'loaded';
var TOKEN = exports.TOKEN = 'token';
var PING = exports.PING = 'ping';
var STYLE = exports.STYLE = 'style';
var ERROR = exports.ERROR = 'error';
var AUTO_SUBMIT = exports.AUTO_SUBMIT = 'autoSubmit';
var UPDATE = exports.UPDATE = 'update';
var GET_TOKEN = exports.GET_TOKEN = 'getToken';
var FOCUS = exports.FOCUS = 'focus';
var UPDATE_ISSUER = exports.UPDATE_ISSUER = 'updateIssuer';
var INIT = exports.INIT = 'init';
var FORMAT = exports.FORMAT = 'format';
var SET_PLACEHOLDER = exports.SET_PLACEHOLDER = 'setPlaceholder';
var CLEAR_DATA = exports.CLEAR_DATA = 'clearData';
var CARD_TYPE = exports.CARD_TYPE = 'card';
var CVV_TYPE = exports.CVV_TYPE = 'cvv';
var ACH_TYPE = exports.ACH_TYPE = 'ach';
var SET_ACCOUNT_DATA = exports.SET_ACCOUNT_DATA = 'setAccountData';
var ENABLE_LOGGING = exports.ENABLE_LOGGING = 'enableLogging';
var ENABLE_AUTO_SUBMIT = exports.ENABLE_AUTO_SUBMIT = 'enableAutoSubmit';
var ENABLE3DS = exports.ENABLE3DS = 'enable3DS';
var UPDATE3DS = exports.UPDATE3DS = 'update3DS';
var AMOUNT = exports.AMOUNT = 'amount';
var MONTH = exports.MONTH = 'month';
var YEAR = exports.YEAR = 'year';
var WAIT_FOR_3DS_RESPONSE_TIMEOUT_DEFAULT = exports.WAIT_FOR_3DS_RESPONSE_TIMEOUT_DEFAULT = 2E4;
var AUTO_FORMAT_DEFAULT_SEPARATOR = exports.AUTO_FORMAT_DEFAULT_SEPARATOR = " ";

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IField = function (_React$Component) {
    _inherits(IField, _React$Component);

    function IField(props) {
        _classCallCheck(this, IField);

        var _this = _possibleConstructorReturn(this, (IField.__proto__ || Object.getPrototypeOf(IField)).call(this, props));

        _this.onMessage = function (e) {
            var data = e.data;
            if (e.source !== _this.iFrameRef.current.contentWindow) return;
            switch (data.action) {
                case _constants.LOADED:
                    _this.log("Message received: ifield loaded");
                    _this.onLoad();
                    break;
                case _constants.TOKEN:
                    _this.log("Message received: " + _constants.TOKEN);
                    _this.onToken(data);
                    break;
                case _constants.AUTO_SUBMIT:
                    _this.log("Message received: " + _constants.AUTO_SUBMIT);
                    _this.onSubmit(data);
                    break;
                case _constants.UPDATE:
                    _this.log("Message received: " + _constants.UPDATE);
                    _this.onUpdate(data);
                    break;
                default:
                    break;
            }
            if (_this.props.threeDS.enable3DS && data.eci && data.eci.length && _this.props.type === _constants.CARD_TYPE) {
                _this.log("Message received: eci");
                _this.postMessage(data);
            }
        };

        _this.validateProps();
        _this.iFrameRef = _react2.default.createRef();
        _this.state = {
            iFrameLoaded: false,
            xTokenReceived: false,
            latestErrorTime: new Date(),
            ifieldDataCache: {
                isValid: false,
                length: 0,
                isEmpty: true
            }
        };
        return _this;
    }

    _createClass(IField, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement("iframe", {
                style: this.props.options.iFrameStyle,
                className: this.props.options.iFrameClassName,
                src: this.props.src,
                title: this.props.type,
                ref: this.iFrameRef });
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            window.addEventListener('message', this.onMessage);
            this.ping();
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.removeEventListener('message', this.onMessage);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (this.props.account !== prevProps.account) this.setAccount(this.props.account);
            if (this.props.threeDS.enable3DS) {
                if (this.props.threeDS.enable3DS !== prevProps.threeDS.enable3DS) this.enable3DS(this.props.threeDS.waitForResponse, this.props.threeDS.waitForResponseTimeout);
                if (this.props.threeDS.amount !== prevProps.threeDS.amount) this.update3DS(_constants.AMOUNT, this.props.threeDS.amount);
                if (this.props.threeDS.month !== prevProps.threeDS.month) this.update3DS(_constants.MONTH, this.props.threeDS.month);
                if (this.props.threeDS.year !== prevProps.threeDS.year) this.update3DS(_constants.YEAR, this.props.threeDS.year);
            }
            if (this.props.issuer !== prevProps.issuer) this.updateIssuer(this.props.issuer);
            if (this.props.options.autoFormat) {
                if (this.props.options.autoFormat !== prevProps.options.autoFormat || this.props.options.autoFormatSeparator !== prevProps.options.autoFormatSeparator) this.enableAutoFormat(this.props.options.autoFormatSeparator);
            }
            if (this.props.options.autoSubmit) {
                if (this.props.options.autoSubmit !== prevProps.options.autoSubmit || this.props.options.autoSubmitFormId !== prevProps.options.autoSubmitFormId) this.enableAutoSubmit(this.props.options.autoSubmitFormId);
            }
            if (this.props.options.enableLogging !== prevProps.options.enableLogging) this.enableLogging();
            if (this.props.options.placeholder !== prevProps.options.placeholder) this.setPlaceholder(this.props.options.placeholder);
            if (this.props.options.iFieldstyle !== prevProps.options.iFieldstyle) this.setStyle(this.props.options.iFieldstyle);
        }
        //----------------------Events
        /**
         * 
         * @param {MessageEvent} e 
         */

    }, {
        key: "onLoad",
        value: function onLoad() {
            var props = this.props;
            this.setState({ iFrameLoaded: true });
            this.setAccount(props.account);
            if (props.threeDS.enable3DS) {
                this.enable3DS(props.threeDS.waitForResponse, props.threeDS.waitForResponseTimeout);
                this.update3DS(_constants.AMOUNT, props.threeDS.amount);
                this.update3DS(_constants.MONTH, props.threeDS.month);
                this.update3DS(_constants.YEAR, props.threeDS.year);
            }
            this.init();
            if (props.issuer) this.updateIssuer(props.issuer);
            if (props.options.placeholder) this.setPlaceholder(props.options.placeholder);
            if (props.options.enableLogging) this.enableLogging();
            if (props.options.autoFormat) this.enableAutoFormat(props.options.autoFormatSeparator);
            if (props.options.autoSubmit) this.enableAutoSubmit(props.options.autoSubmitFormId);
            if (props.options.iFieldstyle) this.setStyle(props.options.iFieldstyle);
            if (props.onLoad) props.onLoad();
        }
        /**
         * 
         * @param {{data: TokenData}} param0 
         */

    }, {
        key: "onToken",
        value: function onToken(_ref) {
            var data = _ref.data;

            if (data.result === _constants.ERROR) {
                this.setState({ latestErrorTime: new Date() });
                this.log("Token Error: " + data.errorMessage);
                if (this.props.onError) this.props.onError(data);
            } else {
                this.setState({ xToken: data.xToken });
                if (this.props.onToken) this.props.onToken(data);
            }
        }
        /**
         * 
         * @param {{data: UpdateData}} param0 
         */

    }, {
        key: "onUpdate",
        value: function onUpdate(_ref2) {
            var data = _ref2.data;

            this.setState({
                ifieldDataCache: {
                    length: this.props.type === _constants.CARD_TYPE ? data.cardNumberLength : data.length,
                    isEmpty: data.isEmpty,
                    isValid: data.isValid
                }
            });
            if (data.isValid) {
                this.getToken();
            }
            if (this.props.onUpdate) this.props.onUpdate(data);
        }
        /**
         * 
         * @param {{data: SubmitData}} param0 
         */

    }, {
        key: "onSubmit",
        value: function onSubmit(_ref3) {
            var data = _ref3.data;

            //call first before submit is triggered
            if (this.props.onSubmit) this.props.onSubmit(data);
            if (data && data.formId) {
                document.getElementById(data.formId).dispatchEvent(new Event("submit", {
                    bubbles: true,
                    cancelable: true
                }));
            }
        }
        //----------------------/
        //----------------------Actions

    }, {
        key: "ping",
        value: function ping() {
            var message = {
                action: _constants.PING
            };
            this.logAction(_constants.PING);
            this.postMessage(message);
        }
        /**
         * 
         * @param {AccountData} data 
         */

    }, {
        key: "setAccount",
        value: function setAccount(data) {
            var message = {
                action: _constants.SET_ACCOUNT_DATA,
                data: data
            };
            this.logAction(_constants.SET_ACCOUNT_DATA);
            this.postMessage(message);
        }
    }, {
        key: "init",
        value: function init() {
            var message = {
                action: _constants.INIT,
                tokenType: this.props.type,
                referrer: window.location.toString()
            };
            this.logAction(_constants.INIT);
            this.postMessage(message);
        }
    }, {
        key: "getToken",
        value: function getToken() {
            var message = {
                action: _constants.GET_TOKEN
            };
            this.logAction(_constants.GET_TOKEN);
            this.postMessage(message);
        }
        /**
         * 
         * @param {boolean} waitForResponse 
         * @param {number} waitForResponseTimeout 
         */

    }, {
        key: "enable3DS",
        value: function enable3DS(waitForResponse, waitForResponseTimeout) {
            var message = {
                action: _constants.ENABLE3DS,
                data: {
                    waitForResponse: waitForResponse,
                    waitForResponseTimeout: waitForResponseTimeout
                }
            };
            this.logAction(_constants.ENABLE3DS);
            this.postMessage(message);
        }
        /**
         * 
         * @param {string} fieldName - The field to update
         * @param {string} value 
         */

    }, {
        key: "update3DS",
        value: function update3DS(fieldName, value) {
            var message = {
                action: _constants.UPDATE3DS,
                data: {
                    fieldName: fieldName,
                    value: value
                }
            };
            this.logAction(_constants.UPDATE3DS);
            this.postMessage(message);
        }
        /**
         * 
         * @param {string} issuer 
         */

    }, {
        key: "updateIssuer",
        value: function updateIssuer(issuer) {
            var message = {
                action: _constants.UPDATE_ISSUER,
                issuer: issuer
            };
            this.logAction(_constants.UPDATE_ISSUER);
            this.postMessage(message);
        }
        /**
         * 
         * @param {string} data 
         */

    }, {
        key: "setPlaceholder",
        value: function setPlaceholder(data) {
            var message = {
                action: _constants.SET_PLACEHOLDER,
                data: data
            };
            this.logAction(_constants.SET_PLACEHOLDER);
            this.postMessage(message);
        }
        /**
         * 
         * @param {string} formatChar 
         */

    }, {
        key: "enableAutoFormat",
        value: function enableAutoFormat(formatChar) {
            var message = {
                action: _constants.FORMAT,
                data: {
                    formatChar: formatChar
                }
            };
            this.logAction(_constants.FORMAT);
            this.postMessage(message);
        }
    }, {
        key: "enableLogging",
        value: function enableLogging() {
            var message = {
                action: _constants.ENABLE_LOGGING
            };
            this.logAction(_constants.ENABLE_LOGGING);
            this.postMessage(message);
        }
        /**
         * 
         * @param {string} formId - The ID attribute of the form to trigger submit on
         */

    }, {
        key: "enableAutoSubmit",
        value: function enableAutoSubmit(formId) {
            var message = {
                action: _constants.ENABLE_AUTO_SUBMIT,
                data: {
                    formId: formId
                }
            };
            this.logAction(_constants.ENABLE_AUTO_SUBMIT);
            this.postMessage(message);
        }
    }, {
        key: "setStyle",
        value: function setStyle(data) {
            var message = {
                action: _constants.STYLE,
                data: data
            };
            this.logAction(_constants.STYLE);
            this.postMessage(message);
        }
        //----------------------Public Actions

    }, {
        key: "focusIfield",
        value: function focusIfield() {
            var message = {
                action: _constants.FOCUS
            };
            this.logAction(_constants.FOCUS);
            this.postMessage(message);
        }
    }, {
        key: "clearIfield",
        value: function clearIfield() {
            var message = {
                action: _constants.CLEAR_DATA
            };
            this.logAction(_constants.CLEAR_DATA);
            this.postMessage(message);
        }
        //----------------------/
        //----------------------Helper Functions
        /**
         * 
         * @param {{action: string, data: *}} data 
         */

    }, {
        key: "postMessage",
        value: function postMessage(data) {
            if (!this.state.iFrameLoaded && data.action !== _constants.PING) {
                this.log("Iframe not loaded");
                return;
            }
            this.iFrameRef.current.contentWindow.postMessage(data, '*');
        }
    }, {
        key: "validateProps",
        value: function validateProps() {
            var props = this.props;
            var accountProps = props.account ? props.account.xKey ? props.account.xSoftwareName ? props.account.xSoftwareVersion ? false : 'xSoftwareVersion' : 'xSoftwareName' : 'xKey' : 'account';
            if (accountProps) {
                this.error("Missing " + accountProps);
            }
            if (!props.type) this.error("Missing props (type)");
        }
        /**
         * 
         * @param {string} message
         */

    }, {
        key: "log",
        value: function log(message) {
            if (this.props.options.enableLogging) {
                console.log("IField " + this.props.type + ": " + message);
            }
        }
        /**
         * 
         * @param {string} action
         */

    }, {
        key: "logAction",
        value: function logAction(action) {
            this.log("Sending message " + action);
        }
        /**
         * 
         * @param {string} message
         */

    }, {
        key: "error",
        value: function error(message) {
            console.error("IField " + this.props.type + ": " + message);
        }
        //---------------------------/

    }]);

    return IField;
}(_react2.default.Component);

exports.default = IField;


IField.defaultProps = {
    options: {
        autoFormatSeparator: _constants.AUTO_FORMAT_DEFAULT_SEPARATOR
    },
    account: {},
    threeDS: {
        waitForResponseTimeout: _constants.WAIT_FOR_3DS_RESPONSE_TIMEOUT_DEFAULT
    }
};

/**
 *
 * @typedef TokenData
 * @property {string} result
 * @property {string} xToken
 * @property {string} xTokenType
 * @property {string} errorMessage
 */
/**
 * @typedef UpdateData
 * @property {boolean} isEmpty
 * @property {boolean} isValid
 * @property {number} length
 * @property {number} cardNumberLength
 */
/**
 * @typedef SubmitData
 * @property {string} formId
 */
/**
 * @typedef AccountData
 * @property {string} xKey
 * @property {string} xSoftwareName
 * @property {string} xSoftwareVersion
 */

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ACH_TYPE = exports.CVV_TYPE = exports.CARD_TYPE = undefined;

var _constants = __webpack_require__(0);

Object.defineProperty(exports, "CARD_TYPE", {
    enumerable: true,
    get: function get() {
        return _constants.CARD_TYPE;
    }
});
Object.defineProperty(exports, "CVV_TYPE", {
    enumerable: true,
    get: function get() {
        return _constants.CVV_TYPE;
    }
});
Object.defineProperty(exports, "ACH_TYPE", {
    enumerable: true,
    get: function get() {
        return _constants.ACH_TYPE;
    }
});

var _iField = __webpack_require__(1);

var _iField2 = _interopRequireDefault(_iField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _iField2.default;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ })
/******/ ]);